// extracted by mini-css-extract-plugin
export default {"Container":"TXFVmkjWINsx18i6XyvP","FormSection":"saJuXLpt2jaYHkGfZHAv","HeadingRow":"PnsSmtRoAgE1d_IoVf6B","Heading":"O60_6tHThdTznQU8QKgx","HorizontalLine":"vMykJoIQS_wjJfVBrh4y"};